type ValueOf<T> = T[keyof T];

export enum ModalType {
  MANAGEPAYPALACCOUNT = 'managePaypalAccount',
  MANAGEVENMOACCOUNT = 'manageVenmoAccount',
  MANAGEBANKACCOUNT = 'manageBankAccount',
  CARDCONNECTEDSUCCESS = 'cardConnectedSuccess',
  DONATECASHBACK = 'donateCashback',
  EDITINFO = 'editInfo',
  DONATECASHBACKSUCCESS = 'donateCashbackSuccess',
  WALLET_INFO = 'walletInfo',
  CARDREMOVESUCCESS = 'cardRemoveSuccess',
  CARDREMOVECONFIRMATION = 'cardRemoveConfirmation',
  TRANSFER_CASHBACK = 'transferCashback',
  TRANSFER_CASHBACK_UNLINKED_CARD = 'transferCashbackUnlinkedCard',
  TRANSFER_CASHBACK_NO_FUNDS = 'transferCashbackNoFunds',
  TRANSFER_CASHBACK_SUCCESS = 'transferCashbackSuccess',
  LOGOUTCONFIRMATION = 'logoutConfirmation',
  CHANGEPASSWORD = 'changePassword',
  CHANGEPASSWORDSUCCESS = 'changePasswordSuccess',
  RESETPASSWORD = 'resetPassword',
  RESETPASSWORDSUCCESS = 'resetPasswordSuccess',
  RESETPASSWORDFAIL = 'resetPasswordFail',
  OFFER_DETAIL = 'offerDetail',
  CONNECTACCOUNT = 'connectAccount',
  IMPACTSCREEN = 'impactScreen',
  EMAIL_INFO = 'emailInfo',
  ADDCARD = 'ADDCARD',
  EDITCARD = 'EDITCARD',
  DELETEACCOUNT = 'deleteAccount',
}

export enum EntryPrivacy {
  PRIVATE = 'entries_private',
  PUBLIC = 'entries_public',
}

export enum PayoutTypeToModalType {
  PAYPAL = 'managePaypalAccount',
  VENMO = 'manageVenmoAccount',
  BANK = 'manageBankAccount',
}

export enum PayoutAccountType {
  PAYPAL = 'paypal',
  VENMO = 'venmo',
  BANK = 'bank',
  HYPERWALLET = 'users',
  NONE = '',
}

type AccountTypes = `${PayoutAccountType}`;
export type ViableAccountsType = Exclude<AccountTypes, '' | 'users'>;

export enum PageTypeCausePage {
  default = 1,
  OnBoarding = 2,
}

export enum APIResponseStatus {
  USER_NOT_FOUND = 401,
  VALIDATION_ERR = 422,
  INCORRECT_CURRENT_PASSWORD = 404,
}

export enum AddCardChangeBasedOnPages {
  ONBOARDING_ADD_CARD = 'onboarding-add-card',
  NATIVE_BROWSER = 'native-browser',
  MOBILE_WEB_ONBOARDING = 'mobile-web-onboarding',
}

export enum PagesUrl {
  CAUSES = '/causes',
  ABOUT_US = '/story',
  TERMS_of_SERVICE = '/terms',
  PRIVACY_POLICY = '/privacy',
  DO_NOT_SELL = '/do-not-sell',
  PROFILE = '/profile',
  SETTINGS = '/settings',
  WALLET = '/wallet',
  WALLET_PURCHASES = '/wallet/purchases',
  WALLET_EARNINGS = '/wallet/earnings',
  ACCOUNT = '/account',
  ALL_OFFERS = '/offers',
  ONLINE_OFFERS = '/offers/online',
  DINING_OFFERS = '/offers/dining',
  IN_STORE_OFFERS = '/offers/in-store',
}

export enum OfferTabs {
  ALL = PagesUrl.ALL_OFFERS,
  IN_STORE = PagesUrl.IN_STORE_OFFERS,
  ONLINE = PagesUrl.ONLINE_OFFERS,
  DINING = PagesUrl.DINING_OFFERS,
}
export enum ProfileWalletTabs {
  PROFILE = PagesUrl.PROFILE,
  WALLET = PagesUrl.WALLET,
}
export enum ProfileWalletTabsHeading {
  PROFILE = 'Profile',
  WALLET = 'Wallet',
}

export enum OfferTabsHeading {
  ALL = 'All Offers',
  IN_STORE = 'In-Store Offers',
  IN_STORE_MOBILE = 'In-Store',
  ONLINE = 'Online Offers',
  ONLINE_MOBILE = 'Online',
  DINING = 'Local Dining',
  VIEWALL_DINING = 'View All Dining',
}

export enum SocialMedia {
  TWITTER = 'https://twitter.com/givebacksgenie',
  FACEBOOK = 'https://www.facebook.com/Givebacks/',
  INSTAGRAM = 'https://www.instagram.com/givebacksgenie/',
}
export enum AppLink {
  ANDROID = 'https://play.google.com/store',
  APPLE = 'https://www.apple.com/app-store',
}

export enum EXTENSION {
  BROWSER = 'https://chrome.google.com/webstore/detail/givebacks/djidapogageiehhmihamgimggepbnojp',
  ID = 'djidapogageiehhmihamgimggepbnojp',
  INSTALLATIONPATH = 'chrome-extension://djidapogageiehhmihamgimggepbnojp/oauth.html',
}
export enum FAQ {
  GENERAL_FAQ_URL = 'https://support.givebacks.com/hc/en-us/sections/4422614188823-Getting-Started',
  CASHBACK_FAQ_URL = 'https://support.givebacks.com/hc/en-us/sections/4422527467927-All-things-Cash-Back',
  CONTACT_US_URL = 'https://support.givebacks.com/hc/en-us/requests/new',
  HELP_CENTER_URL = 'https://support.givebacks.com/en/collections/11211633-the-givebacks-app',
}

export const Month = [
  'Jan - 01',
  'Feb - 02',
  'Mar - 03',
  'Apr - 04',
  'May - 05',
  'June - 06',
  'July - 07',
  'Aug - 08',
  'Sept - 09',
  'Oct - 10',
  'Nov - 11',
  'Dec - 12',
];

export const Week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const Weekday = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export enum OfferType {
  IN_STORE = 'in_store',
  DINING = 'dining',
  FEATURED = 'featured',
  ONLINE = 'online',
  ALL = '',
}

export enum SortBy {
  PROXIMITY = 'Proximity',
  MOST_RECENT = 'Most Recent',
  HIGHEST_CAHBACK = 'Highest Cashback %',
}

export enum FilterBy {
  ALL = 'All Offers',
  IN_STORE = 'In-Store Offers',
  ONLINE = 'Online Offers',
  DINING = 'Dining Offers',
}
export enum ResetPasswordFormStatus {
  Success = 1,
  ValidationFail = 2,
  Pending = 0,
}

export enum OfferSearchResultType {
  Trending = 'Trending',
  Online = 'Online',
  Instore = 'In-Store',
}

export const API_ERROR = 404;

const url = () => {
  switch (import.meta.env.VITE_API_ENV || 'staging') {
    case 'development':
      return `https://app.givebacks.dev`;
    case 'staging':
      return `https://app.givebacks.dev`;
    case 'production':
      return `https://www.givebacks.com`;
    default:
      return `https://app.givebacks.dev`;
  }
};

/**
 * This is an alternative enum pattern to the built in TypeScript enum
 * This pattern provides better intellisense for the specific values of the union type instead of only displaying the name of the enum for an enhanced developer experience
 */
export const SUBDOMAINS = { DONATE: 'donate', WALLET: 'wallet' } as const;
type Subdomains = ValueOf<typeof SUBDOMAINS>;

export const specificSubDomain = (subdomain: Subdomains) => {
  if (import.meta.env.VITE_API_ENV === 'production') {
    return `https://${subdomain}.givebacks.com`;
  }

  return `https://${subdomain}.givebacks.dev`;
};

/**
 * Used for NPO site routing, since subdomain can be cause name
 * Return base supporter app if no subdomain is provided, but regardless an empty string should not be allowed
 * We determine top level domain (tld) based on environment
 * @param subdomain
 * @returns
 */
export const customSubDomain = (subdomain: string) => {
  const tld = import.meta.env.VITE_API_ENV === 'production' ? 'com' : 'dev';

  if (!subdomain) {
    return `https://www.givebacks.${tld}`;
  }

  return `https://${subdomain}.givebacks.${tld}`;
};

export enum MOBILE_ROUTES {
  finishiOSOnboarding = '/IosExtensionOnboardingFinished',
  native = '/native',
}

export enum APP_LINKS {
  android_scheme = 'com.givebacks://native',
  wallet = 'com.givebacks://Wallet',
  android_play_store = 'https://play.google.com/store/apps/details?id=com.givebacks',
  android_market_link = 'market://launch?id=com.givebacks',
  ios_apple_store = 'https://apps.apple.com/us/app/givebacks/id1612867868',
}
export const CONTACT_US_URL = 'https://support.givebacks.com/hc/en-us/requests/new';

export const BASE_URL = url();

export const PAYMENT_METHODS = {
  CARD_TERMINAL: 'card_terminal',
  CASH: 'cash',
  CHECK: 'check',
  CREDIT_CARD: 'credit_card',
  OFFLINE: 'offline',
  POS_CASH: 'pos_cash',
  REWARDS: 'rewards',
  CREDIT_CARD_REWARDS: 'credit_card_rewards',
} as const;

export type PaymentMethods = ValueOf<typeof PAYMENT_METHODS>;

export const PAYMENT_METHODS_MAPPING: Record<PaymentMethods, string> = {
  [PAYMENT_METHODS.CARD_TERMINAL]: 'Credit Card (POS)',
  [PAYMENT_METHODS.CASH]: 'Cash',
  [PAYMENT_METHODS.CHECK]: 'Check',
  [PAYMENT_METHODS.CREDIT_CARD]: 'Credit Card',
  [PAYMENT_METHODS.OFFLINE]: 'Offline Donation',
  [PAYMENT_METHODS.POS_CASH]: 'Cash (POS)',
  [PAYMENT_METHODS.REWARDS]: 'Rewards',
  [PAYMENT_METHODS.CREDIT_CARD_REWARDS]: 'Credit Card + Rewards',
};

export const ACCOUNT_CODE_FEATURES = {
  QUICK_PAY: 'quick_pay',
  POS_DONATION: 'pos_donation',
  PRODUCT_FUNDRAISERS: 'product_fundraisers',
  SHOP_TO_GIVE: 'shop_to_give',
  CAMPAIGN: 'campaign',
  DONATION: 'donation',
  MEMBERSHIP: 'membership',
  PRODUCT: 'product',
  FEES: 'fees',
};

export enum LEGAL_URLS {
  TAX_DEDUCTIBILITY_URL = 'https://support.givebacks.com/hc/en-us/articles/28963827973015-Tax-Deductibility',
  DONATION_DISBURSEMENT_URL = 'https://support.givebacks.com/hc/en-us/articles/28961465884567-Donation-Disbursements',
  TERMS_OF_SERVICE_URL = 'https://www.givebacks.com/terms',
}
